import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const Wrapper = styled.article`
  position: relative;
  display: flex;
  padding: 29px ${({ hasimage }) => hasimage ? '0' : '29px'} 0;
  flex-flow: row wrap;
  align-items: stretch;
  justify-content: center;
  overflow: hidden;
  background: ${({ background }) => background || `white`};
  
  @media (min-width: 768px) {
    padding: 29px 7vw 0;
    justify-content: ${({ justify }) => justify};
    ${({ direction, hasimage }) => {
    let paddingStyle = '';
    if (hasimage) {
      paddingStyle = direction === 'row' ? 'padding-right: 0;' : 'padding-left: 0;'
    }

    return `
        flex-flow: ${direction} nowrap;
        ${paddingStyle}
      `;
  }}
  }
  
  @media (min-width: 1280px) {
    padding: 100px 0 0;

    ${({ direction, hasimage }) => {
    let paddingStyle = '';
    if (hasimage) {
      paddingStyle = direction === 'row' ? 'padding-right: 0;' : 'padding-left: 0;'
    }
    return paddingStyle;
  }}
  }
`;

export const ContentWrapper = styled.section`
  flex: 1;
  padding-bottom: 40px;
  min-width: 333px;
  
  align-self: center;
  box-sizing: content-box;

  ${({ hasimage }) => hasimage && `
    padding-left: 29px;
    padding-right: 29px;
    max-width: 380px;

    @media (min-width: 768px) {
      padding-left: 0;
      padding-right: 0;
    }
  `}
`;

export const ImageWrapper = styled.section`
  flex: 1;
  min-width: 375px;
  max-width: 916px;

  & > .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    margin: auto;
  }

  @media (min-width: 1280px) {
    & > .gatsby-image-wrapper {
      margin: ${({ direction }) => direction === 'row-reverse' ? '0' : 'auto'};
    }
  }
`;

const smallSecondaryText = `
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.71px;

  @media (min-width: 768px) {
    font-size: 14px;
    letter-spacing: 2px;
  }
`;

export const Link = styled(Typography)`
  &.MuiTypography-subtitle2 {
    ${smallSecondaryText}
    text-decoration: underline;
  }
`;

export const Sup = styled(Typography)`
  &.MuiTypography-subtitle2 { 
    ${smallSecondaryText}
  }
`;

export const Text = styled(Typography)`
  &.MuiTypography-body1 {
    font-size: 16px;
    font-weight: 300;
    ${({ color }) => color && `color: ${color};`}
    
    @media (min-width: 768px) {
      font-size: 22px;
    }
  }
`;

export const Title = styled(Typography)`
  &.MuiTypography-h2 {
    font-size: 26px;
    font-weight: 600;
    ${({ fullwidth }) => fullwidth && 'padding-top: 64px;'};

    @media (min-width: 768px) {
      font-size: 35px;
      font-weight: 600;
    }
  }
`;
